import doGet from './get'
import doPut from './put'
import doPost from './post'
import doDelete from './delete'
import doPostFile from './postFile'
import doGetFile from './getFile'

export default {
  doGet,
  doPut,
  doPost,
  doDelete,
  doPostFile,
  doGetFile
}
